// HTML from the API (admin / coach rich text) made safe before it is shown with
// dangerouslySetInnerHTML: no scripts, frames or forms, no on… handlers and no javascript: /
// data:text/html links. Uses the browser's own parser (no extra library). Same rules as the coach
// note cleaner in src/pages/Trackers/MemberJourneyParts.js.
const DROP_TAGS = "script, style, iframe, frame, object, embed, link, meta, base, form";
const URL_ATTRS = /^(href|src|xlink:href|action|formaction)$/i;
const BAD_URL = /^\s*(javascript|vbscript|data:text\/html)/i;

export const cleanHtml = (html) => {
  if (typeof DOMParser === "undefined") return "";
  const doc = new DOMParser().parseFromString(String(html || ""), "text/html");
  doc.body.querySelectorAll(DROP_TAGS).forEach((el) => el.remove());
  doc.body.querySelectorAll("*").forEach((el) => {
    [...el.attributes].forEach(({ name, value }) => {
      if (/^on/i.test(name) || (URL_ATTRS.test(name) && BAD_URL.test(value))) {
        el.removeAttribute(name);
      }
    });
  });
  return doc.body.innerHTML;
};
